import React from 'react';
import { Button } from '@vwfs-bronson/bronson-react';
import { useTranslation } from 'react-i18next';
import { ErrorNotification } from '../../../../notifications/error/ErrorNotification';

export type NoConnectionViewProps = {
    cancelEditing: () => void;
};

export const NoConnectionView: React.FC<NoConnectionViewProps> = ({ cancelEditing }) => {
    const { t } = useTranslation();

    return (
        <>
            <ErrorNotification testId={'no-connection'} className={`u-mb`} />
            <Button secondary onClick={cancelEditing} testId="cancelButton" type="button">
                {t('translation:editable-section-nav.back')}
            </Button>
        </>
    );
};
